import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { getDeviceId } from "./utils/location/device";
import "./index.css";

// Ensure the stable per-tablet device id exists from the first launch, independent of
// geolocation. Without this it was only created lazily when a location record was built.
getDeviceId();

serviceWorkerRegistration.register();

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
